var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunicationCenter = function SvgCommunicationCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 12,
    fill: "#00C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005269",
    d: "M13.04 14.903h13.747a1 1 0 1 0 0-2H13.04a1 1 0 1 0 0 2zm4.476 5.678h9.271a1 1 0 0 0 0-2h-9.27a1 1 0 1 0 0 2zM13.04 9.226h5.624a1 1 0 0 0 0-2H13.04a1 1 0 1 0 0 2zM6.523 22.015a1 1 0 1 0-1.39 1.438l1.696 1.639a1 1 0 0 0 1.397-.008l3.142-3.104a1 1 0 0 0-1.405-1.423l-2.447 2.418-.993-.96zm10.993 4.243a1 1 0 1 1 0-2h9.271a1 1 0 0 1 0 2h-9.27zm-4.032-3.265c0 2.975-2.367 5.379-5.28 5.379-2.913 0-5.28-2.404-5.28-5.38 0-2.974 2.368-5.379 5.28-5.379 2.912 0 5.28 2.405 5.28 5.38zm10.47-20.32l-.088 5.607 5.369.008-5.281-5.615zm6.465 7.617l-7.38-.011a1.185 1.185 0 0 1-1.185-1.207l.102-6.58H9.953c-.358 0-.653.3-.653.678v12.526c3.503.536 6.184 3.602 6.184 7.297s-2.68 6.76-6.184 7.296v.374c0 .64.501 1.15 1.115 1.15h18.89c.612 0 1.114-.511 1.114-1.15V10.29zM7.3 30.316c-3.596-.451-6.374-3.56-6.374-7.323 0-3.762 2.779-6.872 6.375-7.324V3.17C7.3 1.694 8.483.493 9.953.493h14.694l7.772 8.263v21.908c0 1.737-1.39 3.15-3.115 3.15h-18.89c-1.724 0-3.114-1.413-3.114-3.15v-.347z"
  })))));
};
export default SvgCommunicationCenter;